import { pushScopeId, popScopeId, createElementVNode, defineComponent, ref, watchEffect, markRaw, shallowRef, onMounted, watch, computed, openBlock, createElementBlock, createVNode, unref, createCommentVNode, toDisplayString, createBlock, withCtx } from "@histoire/vendors/vue";
import { Icon } from "@histoire/vendors/iconify";
import { setCDN, getHighlighter } from "shiki";
import { HstCopyIcon } from "@histoire/controls";
import { unindent } from "@histoire/shared";
import { clientSupportPlugins } from "virtual:$histoire-support-plugins-client";
import { isDark } from "../../util/dark.js";
import BaseEmpty from "../base/BaseEmpty.js";
import "./StorySourceCode.vue_vue_type_style_index_0_scoped_true_lang.js";
import _export_sfc from "../../_virtual/plugin-vue_export-helper.js";
const _withScopeId = (n) => (pushScopeId("data-v-68151bff"), n = n(), popScopeId(), n);
const _hoisted_1 = { class: "htw-bg-gray-100 dark:htw-bg-gray-800 htw-h-full htw-overflow-hidden htw-flex htw-flex-col" };
const _hoisted_2 = {
  key: 0,
  class: "htw-h-10 htw-flex-none htw-border-b htw-border-solid htw-border-gray-150 dark:htw-border-gray-850 htw-px-4 htw-flex htw-items-center"
};
const _hoisted_3 = /* @__PURE__ */ _withScopeId(() => /* @__PURE__ */ createElementVNode("div", { class: "htw-text-gray-900 dark:htw-text-gray-100" }, " Source ", -1));
const _hoisted_4 = /* @__PURE__ */ _withScopeId(() => /* @__PURE__ */ createElementVNode("div", { class: "htw-flex-1" }, null, -1));
const _hoisted_5 = {
  key: 1,
  class: "htw-text-red-500 htw-h-full htw-p-2 htw-overflow-auto htw-font-mono htw-text-sm"
};
const _hoisted_6 = /* @__PURE__ */ _withScopeId(() => /* @__PURE__ */ createElementVNode("span", null, "Not available", -1));
const _hoisted_7 = ["value"];
const _hoisted_8 = {
  key: 4,
  class: "htw-w-full htw-h-full htw-overflow-auto",
  "data-test-id": "story-source-code"
};
const _hoisted_9 = ["innerHTML"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "StorySourceCode",
  props: {
    story: null,
    variant: null
  },
  setup(__props) {
    const props = __props;
    const generateSourceCodeFn = ref(null);
    watchEffect(async () => {
      var _a;
      const clientPlugin = clientSupportPlugins[(_a = props.story.file) == null ? void 0 : _a.supportPluginId];
      if (clientPlugin) {
        const pluginModule = await clientPlugin();
        generateSourceCodeFn.value = markRaw(pluginModule.generateSourceCode);
      }
    });
    const sourceCode = ref("");
    const highlighter = shallowRef();
    const error = ref(null);
    onMounted(async () => {
      setCDN("https://unpkg.com/shiki@0.10.1/");
      highlighter.value = await getHighlighter({
        langs: [
          "html",
          "jsx"
        ],
        themes: [
          "github-light",
          "github-dark"
        ]
      });
    });
    watch(() => [props.variant, generateSourceCodeFn.value], async () => {
      var _a, _b, _c, _d;
      if (!generateSourceCodeFn.value)
        return;
      error.value = null;
      try {
        if (props.variant.source) {
          sourceCode.value = props.variant.source;
        } else if ((_b = (_a = props.variant).slots) == null ? void 0 : _b.call(_a).source) {
          const source = (_d = (_c = props.variant).slots) == null ? void 0 : _d.call(_c).source()[0].children;
          if (source) {
            sourceCode.value = await unindent(source);
          }
        } else {
          sourceCode.value = await generateSourceCodeFn.value(props.variant);
        }
      } catch (e) {
        console.error(e);
        error.value = e.message;
      }
    }, {
      deep: true,
      immediate: true
    });
    const sourceHtml = computed(() => {
      var _a;
      return sourceCode.value ? (_a = highlighter.value) == null ? void 0 : _a.codeToHtml(sourceCode.value, {
        lang: "html",
        theme: isDark.value ? "github-dark" : "github-light"
      }) : "";
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [
        !error.value ? (openBlock(), createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _hoisted_4,
          createVNode(unref(HstCopyIcon), {
            content: sourceCode.value,
            class: "htw-flex-none"
          }, null, 8, ["content"])
        ])) : createCommentVNode("", true),
        error.value ? (openBlock(), createElementBlock("div", _hoisted_5, " Error: " + toDisplayString(error.value), 1)) : !sourceCode.value ? (openBlock(), createBlock(BaseEmpty, { key: 2 }, {
          default: withCtx(() => [
            createVNode(unref(Icon), {
              icon: "carbon:code-hide",
              class: "htw-w-8 htw-h-8 htw-opacity-50 htw-mb-6"
            }),
            _hoisted_6
          ]),
          _: 1
        })) : !unref(sourceHtml) ? (openBlock(), createElementBlock("textarea", {
          key: 3,
          class: "__histoire-code-placeholder htw-w-full htw-h-full htw-p-4 htw-outline-none htw-bg-transparent htw-resize-none htw-m-0",
          value: sourceCode.value,
          readonly: "",
          "data-test-id": "story-source-code"
        }, null, 8, _hoisted_7)) : (openBlock(), createElementBlock("div", _hoisted_8, [
          createElementVNode("div", {
            class: "__histoire-code htw-p-4 htw-w-fit",
            innerHTML: unref(sourceHtml)
          }, null, 8, _hoisted_9)
        ]))
      ]);
    };
  }
});
var StorySourceCode = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-68151bff"]]);
export { StorySourceCode as default };
